// @ts-ignore
import { fetchFlights } from "@store/services/fetchCheckoutData";
import { ActionTree } from "vuex";
import { IStore } from "@store/index";
import { FlightState } from "./index";
import Flights from "./interfaces/flights";
import { AxiosError, AxiosResponse } from "axios";

export default {
    async getAvailableFlights({ state, commit, dispatch, rootState }) {
        // params appointmentHash & tripId are obsolete - can be removed in the future. (NSDJW-6038)
        await fetchFlights(
            rootState.checkout.apiEndpoint,
            rootState.checkout.checkoutSummary.tripId,
            rootState.checkout.checkoutSettings.appointmentHash,
            rootState.checkout.apiToken,
            rootState.checkout.checkoutSettings.sessionId,
            rootState.checkout.checkoutSettings.departureAirport,
            rootState.checkout.checkoutSummary.fare,
            rootState.checkout.checkoutSettings.locale
        )
            .then((response: AxiosResponse) => {
                commit('setAvailableFlights', response.data.flights);

                dispatch('restoreSelectedFlight');

                if (state.selectedFlight.id === '') {
                    let selectedFlight;
                    const cheapestFlight = state.availableFlights.find((flight: Flights) => flight.type === 'Cheapest')

                    if (cheapestFlight) {
                        selectedFlight = cheapestFlight;
                    } else {
                        selectedFlight = state.availableFlights[0];
                    }
                    dispatch('handleSelectedFlight', selectedFlight);
                    commit('checkout/setAppointmentId', selectedFlight.appointmentFlightId, { root: true });
                }
            })
            .catch((e: AxiosError) => {
                const responseStatus = e.response ? e.response.status : 'none';
                const message = `Error in getAvailableFlights | Error code: 1642576720275 | HTTP status: ${responseStatus} | ${e.message}`;

                dispatch('openErrorOverlay');

                throw Error(message);
            });
    },
    restoreSelectedFlight ({ state, rootState, dispatch }) {
        if (rootState.checkout.checkoutSettings.restoreId === '') {
            return;
        }

        const restoredFlight: Flights | undefined = state.availableFlights.find((flight: Flights) => flight.appointmentFlightId === rootState.checkout.checkoutSummary.appointmentId);

        if (restoredFlight !== undefined) {
            dispatch('handleSelectedFlight', restoredFlight)
        }
    },
    handleSelectedFlight ({ state, commit, dispatch }, selectedFlight: Flights) {
        commit('setSelectedFlight', [selectedFlight.id, selectedFlight.type]);

        const isValid = state.selectedFlight.id !== '';
        commit('checkout/setIsValid', isValid, { root: true });

        dispatch('funnel/addSelectedToCheckoutFunnel', { type: 'flights', picked: selectedFlight }, { root: true });
    }
} as ActionTree<FlightState, IStore>
